var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-gif w-full"},[_c('img',_vm._b({ref:"img",staticClass:"block w-auto max-w-full mx-auto image-render-crisp",on:{"load":function($event){return _vm.$emit('load')}}},'img',_vm.$attrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }